import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { AuthGuard } from '../auth/auth.guard';
import { UserListComponent } from './components/user-list/user-list.component';
import { UserFormComponent } from './components/user-form/user-form.component';
import { UserDetailComponent } from './components/user-detail/user-detail.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { UserChangePasswordComponent } from './components/user-change-password/user-change-password.component';
import { UserInfoFormComponent } from './components/user-info-form/user-info-form.component';
import { UserResolver } from './resolvers/user.resolver';
import { UserSearchComponent } from './components/user-search/user-search.component';
import { UserListResolver } from './resolvers/user-list.resolver';


const routes: Routes = [
    {
        path: '',
        component: UserListComponent,
        canActivate: [AuthGuard],
        resolve: {
            userListResolverResponse: UserListResolver,
        }
    },
    { path: 'new', component: UserFormComponent, canActivate: [AuthGuard] },
    {
        path: ':userId/detail',
        component: UserDetailComponent,
        canActivate: [AuthGuard],
        resolve: {
            userResolverResponse: UserResolver,
        }
    },
    {
        path: ':userId/edit',
        component: UserFormComponent,
        canActivate: [AuthGuard],
        resolve: {
            userResolverResponse: UserResolver,
        }
    },
    { path: ':userId/change_password', component: UserChangePasswordComponent, canActivate: [AuthGuard] },
];

@NgModule({
    imports: [
        CommonModule,
        RouterModule.forChild(routes),
        FormsModule,
        ReactiveFormsModule,
        SharedModule
    ],
    declarations: [
        UserListComponent,
        UserFormComponent,
        UserDetailComponent,
        UserChangePasswordComponent,
        UserInfoFormComponent,
        UserSearchComponent
    ],
    exports: [],
    entryComponents: []
})

export class UserModule {
    static forRoot() {
        return {
            ngModule: UserModule
        };
    }
}
